module.exports = __webpack_public_path__ + "img/bg.4d2d7fbf.png";